import type { QueryClient } from '@tanstack/react-query';
import { entityToQueryKeyMap } from './entity-to-query-keys';
import type { EntityChangeEvent } from './types';

/**
 * Rilegge le query toccate da un cambio di entità arrivato dal websocket: per
 * ogni prefisso della mappa, quelle che hanno il tenant nella chiave.
 *
 * UNA invalidazione per prefisso, senza casi speciali: il prefisso copre già
 * anche i dettagli (per i tenant settings `['tenant-settings', 'detail', id]`),
 * e una seconda invalidazione annullerebbe il GET della prima.
 */
export function invalidateQueriesForEntityChange(
  queryClient: QueryClient,
  event: EntityChangeEvent
): void {
  invalidateQueriesForEntity(queryClient, event.entity, event.tenantId);
}

/** Stessa rilettura dopo il rientro nella stanza, per recuperare eventi persi. */
export function invalidateQueriesForEntity(
  queryClient: QueryClient,
  entity: EntityChangeEvent['entity'],
  tenantId: string
): void {
  const prefixes = entityToQueryKeyMap[entity] ?? [];
  prefixes.forEach((prefix) => {
    void queryClient.invalidateQueries({
      queryKey: [prefix],
      predicate: (query) => query.queryKey.includes(tenantId),
    });
  });
}
